<div class="order-reference-editor" *ngIf="condition" [formGroup]="detailsFormGroup">

    <div class="row">
        <mat-form-field class="flex-grow" appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.masterdata.firstLoadCarrier.orderReference"></sc-dictionary-label>
          </mat-label>
            <input matInput formControlName="orderReference" name="orderReference" maxlength="255"
                [maxlength]="255">
        </mat-form-field>
    </div>
</div>
